export const GA_MEASUREMENT_ID = process.env.GA_MEASUREMENT_ID || '';

let gaLoaded = false;

export function trackPageview() {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search,
  });
}

export function initGA(measurementId = null, userId = null) {
  if (typeof window === 'undefined') return;

  if (gaLoaded) {
    return;
  }
  const config = { debug_mode: true, send_page_view: false };
  if (userId) {
    config.user_id = userId;
  }

  if (!document.getElementById('ga4-gtag')) {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId || GA_MEASUREMENT_ID)}`;
    s.id = 'ga4-gtag';
    document.head.appendChild(s);
  }

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', measurementId || GA_MEASUREMENT_ID, config);

  gaLoaded = true;
}

export function trackGAEvent(eventName, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  try {
    window.gtag('event', eventName, params);
  } catch {
    // no-op
  }
}

export function trackFollowUpEvent(eventName, eventLabel) {
  if (typeof window === 'undefined') return;
  if (!window.location.pathname.startsWith('/followup')) return;
  trackGAEvent(eventName, {
    event_category: 'follow_up',
    eventLabel,
  });
}
